import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route } from "react-router-dom";
import { RepositoryList } from "./repositoryList";
import { RepositoryDetailRoute } from "./repositoryDetailRoute";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";

const RepositoryRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<RepositoryList />} />
        <Route path={`*`} element={<RepositoryDetailRoute />} />
      </Routes>
    </Layout>
  );
};

export default RepositoryRoute;
